import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select";

// Connects to data-controller="tom-select"
export default class extends Controller {
  static targets = ["select", "externalData", "tags", "emails", "componentField"]

  selectTargetConnected(element) {
    new TomSelect(element,{
      sortField: {
        field: "text",
        direction: "asc"
      }
    });
  }

  emailsTargetConnected(element){
    let loading = 0
    const emails = new TomSelect(element,{
      create: true,
      valueField: 'email',
      labelField: 'email',
      searchField: ['email'],
      createFilter: element.dataset.regex,
      onItemAdd(value, $item){
        console.log("OnItemAdd Trigger", this)
        this.setTextboxValue('')
      },
      load: function(query, callback) {
        let url = element.dataset.url
        if( loading >= 1 ){
          callback();
          return;
        }
        // if(query){url = url + '?q=' + encodeURIComponent(query);}
        fetch(url)
        .then(response => response.json())
        .then(json => {
          loading++
          callback(json);
          this.setValue(element.dataset.startingValue)
        }).catch(()=>{
          callback();
        });
      },
    });
    let selfEmail = document.querySelector("#add-self-email")
    selfEmail.addEventListener("click", function() {
      emails.createItem(selfEmail.dataset.email);
      selfEmail.closest('form').requestSubmit()
    });
  }

  componentFieldTargetConnected(element){
    const dropdownId = element.id;
    const startingInforNumber = element.dataset.startingInforNumber
    const startingIds = element.dataset.startingIds
    const startingValue = element.dataset.startingValue
    let url = element.dataset.url
    let warehouse = element.dataset.warehouse
    const tomSelect = new TomSelect(element,{
      valueField: 'id',
      labelField: 'part_number',
      searchField: ['part_number', 'name', 'infor_number', 'description'],
      // fetch remote data
      load: function(query, callback) {
        url = element.dataset.url
        console.log(url)
        if(Array.isArray(query)){
          url = url + '?ids=' + encodeURIComponent(query);
        }else{
          if(query){
            url = url + '?q=' + encodeURIComponent(query);
            if(warehouse){ url = url + `&warehouse_id=${warehouse}`}
          }
        }
        fetch(url)
        .then(response => response.json())
        .then(json => {
          callback(json);
        }).catch(()=>{
          callback();
        });
      },
      render: {
        option: function(data, escape) {
          return `<div><div class="flex border-dotted border-b gap-6 ${escape(data.background)}">
                    <div class="grid content-center">
                      ${data.main_image ? `<img class="object-contain max-h-20 max-w-40" src="${escape(data.main_image)}" width="150" height="150">` : ''}
                    </div>
                    <div class="grid content-center">
                      <div>
                      <div clas="flex">
                        <h4>${escape(data.part_number)}</h4>
                        <div class="ml-auto text-danger">${escape(data.message)}</div
                      </div>
                      <h3>${escape(data.name)}</h3>
                      <div class='flex gap-2'>
                        <h5>${escape(data.infor_number)}</h5>
                        ${data.new_component ? `<div>${data.new_component}</div>` : ''}
                      </div>
                    </div></div>
                  </div></div>`;
        },
        item: function(data, escape) {
          return `<div><div class="flex gap-6 item ${escape(data.background)}">
          <div class="grid content-center">
            ${data.main_image ? `<img class="object-contain max-h-20 max-w-40" src="${escape(data.main_image)}" width="150" height="150">` : ''}
          </div>
          <div class="grid content-center">
            <div>
              <h3>${escape(data.name)}</h3>
              <h4>${escape(data.part_number)}</h4>
              <div class='flex gap-2'>
                <h5>${escape(data.infor_number)}</h5>
                ${data.new_component ? `<div>${data.new_component}</div>` : ''}
              </div>
          </div></div>
        </div></div>`;
        }
      }
    })

    this.initializeSelect({
      tomSelect: tomSelect,
      url: url,
      startingValue: startingValue,
      startingInforNumber: startingInforNumber,
      startingIds: startingIds
    })


    // if(startingInforNumber){
    //   tomSelect.load(startingInforNumber, "SOMETHING")
    // }else if(startingIds){
    //   tomSelect.load(JSON.parse(startingIds))
    //   setTimeout(() => {
    //     tomSelect.setValue(JSON.parse(startingIds))
    //   }, 2000);
    // }
    // if(startingValue){
    //   setTimeout(() => {
    //     tomSelect.setValue(JSON.parse(startingValue));
    //   }, 2000);
    // }
  }

  initializeSelect({ tomSelect, url, startingValue, startingIds, startingInforNumber }){
    let initialUrl
    let idsToLoad

    if (!tomSelect || !url) {
      console.error("initializeSelect requires 'tomSelect' and 'url' properties in its options object.");
      return;
    }

    if(startingIds){
      idsToLoad = JSON.parse(startingIds);
    }

    if(startingValue){
      idsToLoad = JSON.parse(startingValue);
    }

    if(startingInforNumber){
      initialUrl = `${url}?q=${encodeURIComponent(startingInforNumber)}`;
      fetch(initialUrl)
      .then(res => res.json())
      .then(items => {
        if (Array.isArray(items)) {
            items.forEach(item => {
                tomSelect.addOption(item);
            });
        }
        tomSelect.setValue(idsToLoad);
      })
      .catch(error => {
        console.error("Failed to load initial value for TomSelect:", error);
      });
    }else{
      if (startingValue || startingIds) {
        if (!idsToLoad || (Array.isArray(idsToLoad) && idsToLoad.length === 0)) { return; }
        initialUrl = `${url}?ids=${encodeURIComponent(JSON.stringify(idsToLoad))}`;
        fetch(initialUrl)
          .then(res => res.json())
          .then(items => {
            if (Array.isArray(items)) {
                items.forEach(item => {
                    tomSelect.addOption(item);
                });
            }
            tomSelect.setValue(idsToLoad);
          })
          .catch(error => {
            console.error("Failed to load initial value for TomSelect:", error);
          });
      }
    }

  }

  tagsTargetConnected(element) {
    new TomSelect(element,{
      valueField: 'id',
      labelField: 'display',
      searchField: ['name', 'display'],
      render: {
        option: function(data, escape) {
          if(data.display){
            return JSON.parse(data.display);
          }
        },
        item: function(data, escape) {
          if(data.display){
            return JSON.parse(data.display);
          }
        }
      }
    });
  }


}


